import React from "react"
import Helmet from "react-helmet"

import Layout from "../components/layout"

const Articles = () => (
  <Layout>
    <Helmet title="Articles | Roberttables" />
    <h1>Artcicles Page</h1>
  </Layout>
)

export default Articles
